import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from "react";
import { ErrorNotice } from "@jutro/components";
import { useAuth } from "@jutro/auth";
import { messages } from "./AuthErrorPage.messages";
var managedErrors = {
    access_denied: {
      name: messages.accessDenied,
      message: messages.accessDeniedMessage
    },
    missing_auth: {
      name: messages.authErrorTitle,
      message: messages.authErrorMessage
    }
  },
  useMessageDetails = function (error) {
    var auth = function () {
        try {
          return useAuth();
        } catch (_unused) {
          return;
        }
      }(),
      _error$name = error.name,
      name = void 0 === _error$name ? messages.genericError : _error$name,
      errorCode = error.errorCode,
      _error$message = error.message,
      message = void 0 === _error$message ? error.toString() : _error$message,
      _error$actions = error.actions,
      actions = void 0 === _error$actions ? auth ? [{
        label: messages.logout,
        callback: auth.logout
      }] : [] : _error$actions;
    return errorCode in managedErrors ? _objectSpread(_objectSpread({}, managedErrors[errorCode]), {}, {
      actions: actions
    }) : {
      name: name,
      message: message,
      actions: actions
    };
  };
export var AuthErrorPage = function (_ref) {
  var error = _ref.error,
    _useMessageDetails = useMessageDetails(error),
    name = _useMessageDetails.name,
    message = _useMessageDetails.message,
    actions = _useMessageDetails.actions;
  return React.createElement(ErrorNotice, {
    noticeStyle: "fullHeight",
    mainMessage: name,
    detailedMessage: message,
    actions: actions
  });
};
AuthErrorPage.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "AuthErrorPage"
}, AuthErrorPage.__docgenInfo = {
  componentName: "AuthErrorPage",
  packageName: "@jutro/app",
  description: "",
  displayName: "AuthErrorPage",
  methods: [],
  actualName: "AuthErrorPage"
};